import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import GenericButton from "@ui-components/Button/GenericButton";
import { formatDate, withFallback } from "kontrolEdge/helpers/formattersShappedData";

export interface Port {
	id: number;
	portId: string;
	name: string;
	tag: string[];
	lag: string[]
	renewDate: string;
	renewDateRaw: Date | null;
	term: string;
	serviceType: string;
	portType: string;
	latestStatus: string;
	capacity: number;
	crossConnectId: string;
	customer?: {
		name: string
		id: number;
		chargebeeCustomerId: string
	}
	state: {
		actualState: string
	}
	latestStatustime: string;
	type?: string;
}

const statusRank = (s?: string | null) => {
	if (s === "up") return 3;         // Active
	if (s === "warning") return 2;    // Warning
	if (s === "down") return 1;       // Down
	return 0;                         // Unknown / null / anything else
  };

export const portsColumns: GenericTableColumn<Port>[] = [
	{
		header: "Port ID",
		accessor: "portId",
		renderCell: (row) => <GenericButton variant="brand" label={row.portId} />,
	},
	{
		header: "Name",
		accessor: "name"
	},
	{
		header: "Status",
		renderCell: row => {
			const status = row.state?.actualState;
			let variant: "success"|"default"|"error"|"warning";
			let label: string;
			if (status === "up") {
			variant = "success";
			label = "Active";
		} else if (status === undefined || status === null) {
			variant = "default";
			label = "Unknown";
		} else if (status === "down") {
			variant = "error";
			label = "Down";
		} else {
			variant = "warning";
			label = "Warning";
		}
		return <GenericTag variant={variant} label={label} size="small"/>;
		},
		sortAccessor: (row) => statusRank(row.state?.actualState),	
	},
	{
		header: "Capacity",
		renderCell: (row) => <div>{row.capacity/ 1000} Gbps</div>,
	},
	{
		header: "Tag",
		renderCell: (row) => (
			<GenericTag
				variant="neutral"
				size="small"
				label={
				Array.isArray(row.tag) ? row.tag.join(" ") : row.tag
				}
			/>
		),
	},
	{
		header: "Cross Connect ID",
		renderCell: (row) => <div>{row.crossConnectId}</div>,
	},
	{
		header: "Term",
		renderCell: (row) => <div>{row.term}</div>,
	},
	{
		header: "Renew Date",
		accessor: "renewDate",
	},
	{
		header: "Details",

		accessor: "name",
		renderCell: (row) => (
			<div>
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View port detail:", row);
					}}
				>
					View
				</button>
			</div>
		),
	},
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shapePortData = (ports: any[]): Port[] => {
	return ports.map((p) => {
		const customer = p.customer
		? {
			name: p.customer.name ?? "-",
			id: p.customer.id ?? "-",
			chargebeeCustomerId: p.customer.chargebeeCustomerId ?? "-"
			}
		: undefined;

		const rawDate = p.renewDate ? new Date(p.renewDate) : null;
		const capNum = Number(
		typeof p.capacity === "number" ? p.capacity : String(p.capacity ?? "").replace(/,/g, "")
		);

	return {
		id: p.id,
		portId: withFallback(p.portId),
		name: withFallback(p.name),
		customer,
		crossConnectId: p.crossConnectId,
		renewDateRaw: rawDate && !isNaN(rawDate.getTime()) ? rawDate : null,
		capacity: Number.isFinite(capNum) ? capNum : 0,
		renewDate: formatDate(p.renewDate),
		term: withFallback(p.term) + " " + withFallback(p.term_unit),
		serviceType: withFallback(p.type),
		portType:withFallback(p.portType),
		latestStatus: withFallback(p.latestStatus),
		latestStatustime: withFallback(p.latestStatustime),
		state: {
			actualState: withFallback(p.state?.actualState),
		},
		tag: Array.isArray(p.tag) ? p.tag : [withFallback(p.tag)],
		lag: Array.isArray(p.lag) ? p.lag : [],
	}});
  };

